import React from 'react';
import Link from 'next/link';
import CompanyTopButton from '@components/company/v1/detail/companyTopButton';
import classnames from 'classnames/bind';
import styles from './declaration.module.scss';
const cx = classnames.bind(styles);

const Declaration = () => {
  return (
    <>
      <div className={cx('section1')}>
        <div className={cx('sectionBg')} />
        <div className={cx('sectionInner')}>
          <div className={cx('titleArea')}>
            <div className={cx('text')}>잡다 선언문</div>
            <div className={cx('title')}>
              <strong className={cx('emphasis')}>잡다는 대한민국의</strong>
              <br />
              역량중심 사회를 지향합니다.
            </div>
          </div>

          <ul className={cx('infoList')}>
            <li className={cx('listItem', 'type1')}>
              <div className={cx('hidden')}>청년 여러분들께 약속합니다. Promise</div>
              <div className={cx('listContent')}>
                <div className={cx('desc')}>
                  기회가 불공평한가요?
                  <br />
                  결과가 불공정한가요?
                  <br />
                  함께 하고 싶은 기업은 어디에 있을까요?
                </div>
                <div className={cx('desc')}>
                  매칭 플랫폼 잡다는
                  <br />
                  스펙이 아닌 역량으로
                  <br />
                  나의 능력을 알고
                  <br />
                  내가 성장할 수 있는 기업을 매칭합니다.
                </div>
                <em className={cx('text')}>
                  역량기반 취업으로
                  <br />
                  취업의 문제를 바로 잡습니다.
                </em>
              </div>
            </li>
            <li className={cx('listItem', 'type2')}>
              <div className={cx('hidden')}>기업 여러분들께 약속합니다. Promise</div>
              <div className={cx('listContent')}>
                <div className={cx('desc')}>
                  뽑을 기회가 없으신가요?
                  <br />
                  뽑을 사람이 없으신가요?
                  <br />
                  함께 하고 싶은 인재는 어디에 있을까요?
                </div>
                <div className={cx('desc')}>
                  매칭 플랫폼 잡다는
                  <br />
                  기업에 대한 올바른 정보제공과
                  <br />
                  다양한 역량기반 인재풀을 통해
                  <br />
                  함께 성장할 수 있는 인재를 매칭합니다.
                </div>
                <em className={cx('text')}>
                  역량기반 채용으로
                  <br />
                  올바른 채용문화를 만들겠습니다.
                </em>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className={cx('section2')}>
        <div className={cx('sectionInner')}>
          <ul className={cx('infoList')}>
            <li className={cx('listItem', 'type1')}>
              <div className={cx('listInner')}>
                <em className={cx('title')}>
                  잡다는
                  <br />
                  능력과 기회를 매칭합니다.
                </em>
                <div className={cx('text')}>Connect capability to opportunity</div>

                <div className={cx('descArea')}>
                  <div className={cx('descWrap')}>
                    <div className={cx('desc')}>
                      잡다는 올바른 정보의 제공으로
                      <br />
                      취업과 채용을 돕는 <div className={cx('emphasis')}>매칭 플랫폼</div>입니다.
                      <br />
                      <div className={cx('emphasis')}>
                        잡다는 사람과 기업의 만남입니다.
                        <br />
                        잡다는 좋은 인재와 좋은 문화의 연결입니다.
                        <br />
                        잡다는 능력과 기회를 매칭합니다.
                      </div>
                    </div>
                    <div className={cx('desc')}>
                      대한민국 취업과 채용시장 문제의 본질은
                      <br />
                      구인과 구직간 ‘기대의 미스매치’와 ‘정보의 미스매치’입니다.
                      <br />
                      잡다는 올바른 정보를 통해
                      <br />
                      구직자에게는 역량을 기반으로 진짜 기회를
                      <br />
                      기업에게는 역량을 기반으로 진짜 인재를
                      <br />
                      올바르게 매칭하여 미스매치의 문제를 해결합니다.
                      <br />이 모든 것의 중심에는 ‘역량’이 있습니다.
                    </div>
                    <div className={cx('desc')}>
                      <div className={cx('emphasis')}>
                        잡다는 역량기반의 취업, 역량기반의 채용,
                        <br />
                        역량기반의 교육을 통해
                      </div>
                      <br />
                      인재를 살리고, 기업을 키우고, 사회를 밝히는
                      <br />
                      공정하고 공평한 세상을 추구합니다.
                    </div>
                  </div>
                </div>
              </div>
              <div className={cx('listInner', 'typeImg')} />
            </li>
            <li className={cx('listItem', 'type2')}>
              <div className={cx('listInner', 'typeImg')} />
              <div className={cx('listInner')}>
                <em className={cx('title')}>
                  스펙을 접고,
                  <br />
                  역량을 잡다.
                </em>
                <div className={cx('text')}>Get Competency, Not Spec</div>

                <div className={cx('descArea')}>
                  <div className={cx('descWrap')}>
                    <div className={cx('desc')}>
                      잡다에서 제공하는 <div className={cx('textEmphasis')}>역검</div>(AI역량검사)은
                      <br />
                      세계 최초의 신경과학 알고리즘과 인공지능(AI)기술이 융합된
                      <br />
                      역량검사 솔루션입니다.
                    </div>
                    <div className={cx('desc')}>
                      20년 동안 자연과학 기반의 사람에 대한 연구를 통해
                      <br />
                      무의식 영역에서 사람의 역량을 볼 수 있는
                      <br />
                      {"'과학의 눈'을 탑재하였습니다."}
                      <br />
                      <div className={cx('emphasis')}>
                        첫째, 생물학과 신경과학 500여편의 심리 및<br />
                        <div className={cx('textWrap')}>행동특성 논문의 메타분석 결과</div>
                        둘째, 10만여명의 빅데이터 기반의 머신러닝 학습
                        <br />
                        셋째, 200여명의 면접전문가와 인사전문가의 평가 데이터 학습
                      </div>
                    </div>
                    <div className={cx('desc')}>
                      <div className={cx('textEmphasis')}>역검</div>은 역량 기반의 최적 인재를
                      <br />
                      합리적으로 선발하기 위한
                      <br />
                      세계 최고 수준의 의사결정 도구이며
                      <br />
                      국내 600여개 기업에서 인재채용에 활용하고 있습니다.
                    </div>
                    <div className={cx('desc')}>
                      또한 <div className={cx('textEmphasis')}>역검</div>은 취업을 준비하는 구직자들에게
                      <br />
                      20세 전후에 형성되는
                      <br />
                      긍정성, 적극성, 전략성, 성실성, 공감, 성찰,
                      <br />
                      메타인지와 같은 핵심역량의 보유수준에 대한
                      <br />
                      정보를 제공합니다.
                      <br />
                      <div className={cx('emphasis')}>
                        첫째, 내적역량을 통한 강점과
                        <br />
                        <div className={cx('textWrap')}>역량유형 기반의 역량 프로파일 해석</div>
                        둘째, 나에게 적합한 기업특성과 직군 및 직무특성의 안내
                        <br />
                        셋째, 역량정보를 바탕으로 면접 및 취업준비 가이드
                      </div>
                      <br />
                      잡다는 지식으로 포장된 가짜 스펙이 아닌
                      <br />
                      역량기반의 진짜 스펙으로
                      <br />
                      나에게 적합한 기업과 직군과 직무를 추천하고 매칭합니다.
                    </div>
                  </div>
                </div>

                <Link href="/acc/tutorial" legacyBehavior>
                  <a className={cx('link')} role="button">
                    역검 지금 체험하기
                  </a>
                </Link>
              </div>
            </li>
            <li className={cx('listItem', 'type3')}>
              <div className={cx('listInner')}>
                <em className={cx('title')}>
                  가짜를 접고,
                  <br />
                  진짜를 잡다.
                </em>
                <div className={cx('text')}>Get real, Not fake</div>

                <div className={cx('descArea')}>
                  <div className={cx('descWrap')}>
                    <div className={cx('desc')}>
                      <div className={cx('emphasis')}>
                        잡다에서 제공하는 기업정보는
                        <br />
                        인증된 직장 선배들이 직접 말해주는
                        <br />
                        기업문화를 바탕으로 한 진짜 정보입니다.
                      </div>
                      <br />
                      기업문화는 기업의 정신과 철학이 반영되어
                      <br />
                      구성원들의 공통된 사고방식과 행동양식으로
                      <br />
                      드러나는 무형의 질서입니다.
                      <br />
                      기업을 판단하는 정보들 중에서
                      <br />
                      조직의 역량과 구성원의 성장 가능성을 확인할 수 있는
                      <br />
                      가장 중요한 척도는 겉으로 드러나지 않는 기업문화입니다.
                    </div>
                    <div className={cx('desc')}>
                      현재 취업과 관련된 정보를 제공하는 많은 서비스들이 있습니다.
                      <br />
                      대다수의 서비스에서 작성자의 신원을 검증할 수 없는 한계,
                      <br />
                      사실 여부가 확인되지 않은 무분별한 비방,
                      <br />
                      가십 위주의 리뷰를 빈번하게 볼 수 있습니다.
                      <br />
                      모든 리뷰들이 거짓이라고 볼 수는 없지만,
                      <br />
                      이러한 정보로 인해 취업준비생의 기업에 대한 반감과
                      <br />
                      회사생활에 대한 두려움은 나날이 커져만 가고 있습니다.
                    </div>
                    <div className={cx('desc')}>
                      기업은 좋은 인재를 채용할 기회를 잃어버리고
                      <br />
                      구직자는 좋은 기업에 입사할 기회를 잃어버리는
                      <br />
                      현실이 안타깝습니다.
                    </div>
                    <div className={cx('desc')}>
                      잡다에서 제공하는 기업정보는
                      <br />
                      <div className={cx('emphasis')}>
                        첫째, 기업의 외연적 정보(재무/사업/기술 등)와
                        <br />
                        <div className={cx('textWrap')}>내연적 정보(조직문화/직원리뷰 등)의 통합 정보</div>
                        둘째, 긍정문화, 성과문화, 가치문화에 대해
                        <br />
                        <div className={cx('textWrap')}>현직자가 직접 소개하는 실질적이고</div>
                        <div className={cx('textWrap')}>구체적인 정보를 시각화 하여 제공</div>
                        셋째, 기업문화를 중심으로 나에게 적합한 기업을
                        <br />
                        <div className={cx('textWrap')}>큐레이팅하여 추천</div>
                      </div>
                      <br />
                      잡다의 모든 기업 정보는 긍정 중심이며,
                      <br />
                      올바른 기업정보의 전달로
                      <br />
                      대한민국의 건전한 채용문화를 지향합니다.
                    </div>
                  </div>
                </div>
              </div>
              <div className={cx('listInner', 'typeImg')} />
            </li>
          </ul>
        </div>
      </div>

      <div className={cx('section3')}>
        <div className={cx('sectionInner')}>
          <div className={cx('titleArea')}>
            <strong className={cx('title')}>청년에게 기회를.</strong>
            <div className={cx('subTitle')}>잡다는 좋은 기업을 찾는 청년에게 3가지 가치를 제공합니다.</div>
            <ul className={cx('infoList')}>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>
                  첫째, 구직 준비에 소요되는 시간과 비용과 노력이 더 이상 필요 없게 됩니다.
                </em>
                <div className={cx('desc')}>
                  <div className={cx('textEmphasis')}>역검</div>(AI역량검사)으로 시간과 장소의 제약없이 언제 어디서나
                  응시할 수 있습니다.
                  <br />
                  취업을 위한 스펙 쌓기, 자기소개서 작성, 인적성 검사 준비 등의 노력과 비용을 해소합니다.
                  <br />
                  한번의 <div className={cx('textEmphasis')}>역검</div>(AI역량검사)으로 모든 취업준비를 마칠 수
                  있습니다.
                </div>
              </li>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>
                  둘째, <div className={cx('textEmphasis')}>역검</div>을 통해 나의 역량을 객관적으로 확인할 수 있습니다.
                </em>
                <div className={cx('desc')}>
                  잡다는 역량이라는 진짜 스펙을 통해 다양한 취업의 기회를 제공합니다.
                  <br />
                  역량은 KSA(지식/기술/태도)로 만들어지지 않습니다.
                  <br />
                  긍정성, 적극성, 전략성, 성실성, 공감, 성찰, 메타인지와 같은
                  <br />
                  핵심역량의 보유수준과 역량유형 및 분석으로
                  <br />
                  내가 무엇을 잘하고 어떤 일을 할 때 성과를 내고 성장가능성이 높은지를
                  <br />
                  객관적으로 확인할 수 있습니다.
                </div>
              </li>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>셋째, 매칭을 통해 나에게 적합한 기업을 추천 받을 수 있습니다.</em>
                <div className={cx('desc')}>
                  잡다는 기업에 대한 올바른 정보와 관점을 제공합니다.
                  <br />
                  기업에 대한 정보부족과 대비부족으로 인한 부정적 불확실성이 해소됩니다.
                  <br />
                  역량기반의 매칭으로 나에게 적합한 기업과 직무 정보를 통해 취업의 기회가 확대됩니다.
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className={cx('section4')}>
        <div className={cx('sectionInner')}>
          <div className={cx('titleArea')}>
            <strong className={cx('title')}>기업에게 인재를.</strong>
            <div className={cx('subTitle')}>잡다는 좋은 인재를 찾는 대한민국 기업에게 3가지 가치를 제공합니다.</div>
            <ul className={cx('infoList')}>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>첫째, 채용업무에 소요되는 시간과 비용과 노력이 대폭 감소됩니다.</em>
                <div className={cx('desc')}>
                  지금은 채용계획수립부터 최종 채용 확정까지 수많은 준비와 실행이 필요합니다.
                  <br />
                  잡다 플랫폼의 인재풀과 추천 그리고 매칭을 이용하면
                  <br />
                  더 이상 채용 포탈을 통한 공고와 홍보가 필요 없으며
                  <br />
                  한정된 자원으로 채용의 많은 업무를 진행하는 수고와 노력이 없어집니다.
                </div>
              </li>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>둘째, 기업이 원하는 적합한 인재를 효과적으로 선발할 수 있습니다.</em>
                <div className={cx('desc')}>
                  잡다는 역량이라는 진짜 스펙을 통해 기업이 원하는 인재선발을 돕습니다.
                  <br />
                  지식과 스펙이 성과를 보장하지 않고, 학력과 경력이 능력을 대변하지 않습니다.
                  <br />
                  면접으로는 사람의 편향과 편견의 한계를 극복하기 어렵습니다.
                  <br />
                  과학의 눈을 통해 무의식 영역의 역량을 파악함으로써
                  <br />
                  우리 기업에 맞는 성과를 내고 성장가능성이 높은 인재를 선발할 수 있습니다.
                </div>
              </li>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>셋째, 다양한 인재풀로 수시상시채용이 가능해 집니다.</em>
                <div className={cx('desc')}>
                  이제는 기업의 채용문화가 정기채용과 공개채용에서
                  <br />
                  수시/상시 채용으로 변화되고 있습니다.
                  <br />
                  잡다에서 제공되는 다양한 인재풀 그리고 인재추천과 매칭서비스는
                  <br />
                  채용담당 인원과 채용업무의 증가없이
                  <br />
                  수시상시 채용이 가능하도록 지원합니다.
                  <br />
                  직군별, 직무별로 성과를 내고 성장가능성이 높은 인재를
                  <br />
                  기업이 원하는 때에 원하는 인재를 선발할 수 있습니다.
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className={cx('section5')}>
        <div className={cx('sectionInner')}>
          <div className={cx('titleArea')}>
            <strong className={cx('title')}>대한민국에게 미래를.</strong>
            <div className={cx('subTitle')}>잡다는 대한민국 사회에 3가지 가치를 제공합니다.</div>
            <ul className={cx('infoList')}>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>첫째, 취업과 채용에 소요되는 사회적 비용이 감소됩니다.</em>
                <div className={cx('desc')}>
                  구직자가 1년동안 취업을 준비하는 비용은 평균 378만원 (2021 인쿠르트 조사)
                  <br />
                  기업에서 직원 1명을 채용하는데 드는 비용은 연간 평균 6240만원 (2018 고용노동부 조사)
                  <br />
                  미스매치로 발생하는 청년 일자리 창출의 사회적 비용은 매년 증가하고 있습니다.
                  <br />
                  잡다는 역량기반 취업과 채용 그리고 수시상시 매칭을 통해
                  <br />
                  취업과 채용에 소요되는 사회적 비용을 감소시키며
                  <br />
                  청년을 위한 새로운 일자리 창출의 기회를 확대합니다.
                </div>
              </li>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>둘째, 기업에 대한 인식이 긍정적이고 친사회적으로 전환됩니다.</em>
                <div className={cx('desc')}>
                  사회적 부를 창출하고 국가경제 발전과 사회공헌의 주체이자 주역은 바로 기업입니다.
                  <br />
                  기업에 대한 부정적 인식은 사회적 신뢰를 저하시키고
                  <br />
                  기업 경영자와 구성원의 동기를 저하시킴으로써 경제 성장과 발전에 악영향을 초래합니다.
                  <br />
                  잡다의 기업정보는 취준생에게 기업에 대한 긍정적 인식을 강화하고
                  <br />
                  기업 구성원들에게도 자부심을 고취시킴으로써
                  <br />
                  기업 성장과 고용 활성화라는 선순환을 유도합니다.
                </div>
              </li>
              <li className={cx('listItem')}>
                <em className={cx('listTitle')}>셋째, 스펙중심 사회에서 역량중심 사회로 변화할 수 있습니다.</em>
                <div className={cx('desc')}>
                  학벌과 학력 중심 채용으로 발생하는 기업 채용에서의 부익부 빈익빈 현상을 해소합니다.
                  <br />
                  대한민국 교육 문제의 핵심은 대학입시 중심의 과다경쟁과 서열화입니다.
                  <br />
                  기업에서 스펙을 보지 않고 역량기반으로 인재를 채용한다면
                  <br />
                  대학의 역할과 교육이 바뀔 것이고,
                  <br />
                  입시 중심의 초중고등학교 교육은 역량기반의 교육으로 혁신될 것이며
                  <br />
                  우리 사회는 누구나 개인의 역량을 발견하고 개발함으로써
                  <br />
                  자기실현을 추구할 수 있는 역량중심 사회로 변화될 것입니다.
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Link href="/jobdafaq" legacyBehavior>
        <a className={cx('section6')} role="button">
          <div className={cx('sectionInner')}>
            <div className={cx('textArea')}>
              <div className={cx('text')}>당신이 궁금해할 만한 것들을 모두 모았어요.</div>
              <strong className={cx('title')}>잡다 FAQ 바로가기</strong>
              <div className={cx('linkText')}>확인하러 가기</div>
            </div>
          </div>
        </a>
      </Link>

      <CompanyTopButton />
    </>
  );
};

export default Declaration;
